module.exports = "https://static.wmbcdn.com/uniweb/images/9706a401935dbee627f7d3443095e313.svg";